import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/pro-regular-svg-icons';
import style from './style.module.scss';

const PopupModal = ({
  isOpen,
  onClose,
  userId,
  text,
  onSendWarning,
  received,
  confirmed,
  setUserId,
  setText,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSendWarning(userId, text);
  };

  if (!isOpen) return null;

  return (
    <Modal show={isOpen} onHide={onClose} centered className={style.warnPopupContainer}>
      <Modal.Header closeButton className={style.header}>
        <Modal.Title>Warn User</Modal.Title>
      </Modal.Header>
      <Modal.Body className={style.body}>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>User ID:</Form.Label>
            <Form.Control
              type="text"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              placeholder="Enter user ID"
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" style={{ display: 'none' }}>
            <Form.Label>Warning Message:</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Enter your warning message here..."
            />
          </Form.Group>
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <FontAwesomeIcon
                icon={received ? faCheck : faXmark}
                style={{ color: received ? '#28a745' : '#dc3545', fontSize: '1.2rem' }}
                className="mr-2"
              />
              <span style={{ color: received ? '#28a745' : '#dc3545', fontWeight: 'bold' }}>
                Received
              </span>
            </div>
            <div className="d-flex align-items-center">
              <FontAwesomeIcon
                icon={confirmed ? faCheck : faXmark}
                style={{ color: confirmed ? '#28a745' : '#dc3545', fontSize: '1.2rem' }}
                className="mr-2"
              />
              <span style={{ color: confirmed ? '#28a745' : '#dc3545', fontWeight: 'bold' }}>
                Confirmed
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-between mt-3">
            <Button variant="secondary" onClick={onClose}>
              Close
            </Button>
            <Button variant="warning" type="submit" disabled={!userId.trim()}>
              Send Warning
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default PopupModal;
